/** Gate for the cc-recipients field in `SendEmailModal`. */
import { useFeatureFlagEnabled } from '@posthog/react';

export const EXPORT_EMAIL_CC_FLAG = 'exports-enable-email-cc';

export function useExportEmailCcEnabled(): boolean {
  return useFeatureFlagEnabled(EXPORT_EMAIL_CC_FLAG) === true;
}
